import TrmChatViewContainer from './TrmChatViewContainer';
export default TrmChatViewContainer;
